import { useState, useEffect, useContext } from 'react';
import {
    searchProductCategory,
    countCategories
} from '../services/CategoryService'

export const useCategory = (filters = {}) => {
    const [productsSearchCategory, setProductsSearchCategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const searchProductCategoryPost = async (param) => {
        try {
            // setLoading(true);
            const response = await searchProductCategory(param);
            
            setProductsSearchCategory(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    const countCategoryProduct = async () => {
        try {
            setLoading(true);
            const response = await countCategories();

            setProductsSearchCategory(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        countCategoryProduct();
    }, []);

    return {
        productsSearchCategory,
        loading,
        searchProductCategoryPost,
        countCategoryProduct

    };
};
